import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { history } from "../../../redux/store/configureStore";
import * as productActions from "../../../redux/actions/productActions";
import { buildManageRouteWithSchoolYear, getNormalizedSchoolYearStartYearFromSearch } from "../manageSchoolYearRouting";

function Products({ products, loadProducts }) {
  const [numToShow, setNumToShow] = useState(25);
  const location = useLocation();
  const activeSchoolYearStartYear = getNormalizedSchoolYearStartYearFromSearch(location.search);
  const visibleProducts = products.filter(product => !product.deleted);

  useEffect(() => {
    if (products.length === 0) {
      loadProducts().catch(error => alert(`Loading products failed ${error}`));
    }
  }, [loadProducts, products.length]);

  const handleAdd = () => {
    history.push(buildManageRouteWithSchoolYear("/manage/product/new", location.search, activeSchoolYearStartYear));
  };

  const handleEdit = (product) => {
    history.push(buildManageRouteWithSchoolYear(`/manage/product/${product.id}`, location.search, activeSchoolYearStartYear));
  };
  const handleEditKeyDown = (event, product) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleEdit(product);
    }
  };

  return (
    <div className="mb-5">
      <div className="row d-flex mx-0">
        <div className="manage-title">Produkty</div>
        <div className="col-block ml-auto">
          <button type="button" className="btn manage-button btn-success btn-block" onClick={handleAdd}>
            Dodaj produkt
          </button>
        </div>
      </div>
      <div className="row table-header manage-table-title mx-0 d-flex align-items-center">
        <div className="col-md-4 col-5">Nazwa</div>
        <div className="col-md-3 col-3">Platnosc</div>
        <div className="col-md-3 col-4">Naliczanie</div>
        <div className="col-md-2 d-none d-md-block">Cena</div>
      </div>
      {visibleProducts.slice(0, numToShow).map((product, index) => (
        <div
          key={product.id}
          role="button"
          tabIndex={0}
          className={`table-row row d-flex manage-text cursor-pointer mx-0 ${index % 2 !== 0 ? "table-row-alternate" : ""}`}
          onClick={() => handleEdit(product)}
          onKeyDown={event => handleEditKeyDown(event, product)}
        >
          <div className="col-md-4 col-5 table-cell">{product.name}</div>
          <div className="col-md-3 col-3 table-cell">{product.paymentStrategy}</div>
          <div className="col-md-3 col-4 table-cell">{product.chargingStrategy}</div>
          <div className="col-md-2 d-none d-md-block table-cell">{product.defaultPrice || ""}</div>
        </div>
      ))}
      {numToShow < visibleProducts.length && (
        <div className="pt-3 row d-flex justify-content-center mx-0">
          <div className="col-md-3 form-group">
            <button type="button" className="btn manage-button manage-red-button btn-block" onClick={() => setNumToShow(numToShow + 25)}>
              Pokaz wiecej
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

Products.propTypes = {
  products: PropTypes.array.isRequired,
  loadProducts: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  products: state.products,
});

const mapDispatchToProps = dispatch => ({
  loadProducts: () => dispatch(productActions.loadProducts()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Products);
